import { Input, Label } from '@iwoca/orion';
import { t, Trans } from '@lingui/macro';
import {
  TRole,
  TSignupFormDataDE,
} from 'components/Signup/NewSignupFormDE/NewSignupFormDE.types';
import { useFormContext } from 'react-hook-form';
import signupFormStyles from '../../SignupForm/SignupForm.module.css';
import styles from './../PersonalDetailsDE.module.css';

type TProps = {
  roleType: TRole;
  addressIndex: number;
  personIndex: number;
};

export const AddressFieldsDE = ({
  roleType,
  addressIndex,
  personIndex,
}: TProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TSignupFormDataDE>();

  const ADDRESS_PROPERTY =
    roleType === 'applicant'
      ? (`applicant.residentialAddresses.${addressIndex}` as const)
      : (`guarantor.${personIndex}.residentialAddresses.${addressIndex}` as const);

  const ERROR_PROPERTY =
    roleType === 'applicant'
      ? errors.applicant?.residentialAddresses?.[addressIndex]
      : errors?.guarantor?.[personIndex]?.residentialAddresses?.[addressIndex];

  return (
    <>
      <div className={signupFormStyles.formField}>
        <div className={styles.addressContainer}>
          <Input
            {...register(`${ADDRESS_PROPERTY}.street_line_1`)}
            className={styles.street}
            type="text"
            placeholder="z.B. Schildgasse"
            label={t`Street`}
            data-testid="address-street"
            error={ERROR_PROPERTY?.street_line_1?.message}
          />
          <Input
            {...register(`${ADDRESS_PROPERTY}.house_number`)}
            type="text"
            placeholder="z.B. 21"
            label={t`House number`}
            data-testid={`${roleType}-house-number`}
            error={ERROR_PROPERTY?.house_number?.message}
          />
        </div>
      </div>
      <div className={signupFormStyles.formField}>
        <Label
          className={styles.label}
          htmlFor={`${ADDRESS_PROPERTY}.street_line_2`}
        >
          <Trans>Address supplement</Trans>
          <span className={styles.optional}>({t`optional`})</span>
        </Label>
        <Input
          {...register(`${ADDRESS_PROPERTY}.street_line_2`)}
          id={`${ADDRESS_PROPERTY}.street_line_2`}
          type="text"
          data-testid="address-supplement"
          placeholder="z.B. Apt 2"
          error={ERROR_PROPERTY?.street_line_2?.message}
        />
      </div>
      <div className={signupFormStyles.formField}>
        <div className={styles.addressContainer}>
          <Input
            {...register(`${ADDRESS_PROPERTY}.postcode`)}
            maxLength={5}
            wrapperClassName={styles.postcode}
            type="text"
            placeholder="z.B. 37269"
            label={t`Postcode`}
            data-testid={`${roleType}-postcode`}
            error={ERROR_PROPERTY?.postcode?.message}
          />
          <Input
            {...register(`${ADDRESS_PROPERTY}.town`)}
            type="text"
            wrapperClassName={styles.town}
            placeholder="z.B. Waldmünchen"
            label={t`Town`}
            data-testid={`${roleType}-town`}
            error={ERROR_PROPERTY?.town?.message}
          />
        </div>
      </div>
    </>
  );
};
